import { useEffect, useState } from "react";
import dailyFilterDefault from '@/pages/dashboard/filterPageComponents/overview/dailyFilterDefault';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { dailyRequest } from "../../pages/overview/_config/dailyRequest";

/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useDailyKeyMetricsModel = (props: any, formValue: any, dispatch: any, filterLoading: boolean,dailyReqType:string='normal') => {
    const { gameCode, serviceData, } = props;
    const formVal = formValue || dailyFilterDefault;
    const [componentData, setComponentData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // 进入页面的时候
    // useEffect(() => {
    //     if (!formValue) return;
    //     const dvaData = serviceData?.[OVERVIEW_DAILY_KEY_METRICS];
    //     // if (dvaData) {
    //     //     setComponentData(dvaData?.data)
    //     // } else {
    //         // 当筛选器加载完成后再进行页面请求
    //         if (!filterLoading) {
    //             getDailyKeyMetricsDataFunc()
    //         }
    //     // }
    // }, [filterLoading])

    // 点击筛选器的时候
    useEffect(() => {
        if (!formValue) return;
        if (!filterLoading) {
            getDailyKeyMetricsDataFunc()
        }
    }, [formVal])


    const getDailyKeyMetricsDataFunc = (isRefresh?: boolean) => {
        const { filterValue } = formValue;
        const { rangeTime: [start, end], ...filters } = filterValue;
        const params = {
            game_code: gameCode,
            filters: formatFilterValues(filters),
            start_time: start,
            end_time: end,
        }

        setLoading(!isRefresh);
        const requestFunc = dailyRequest.getDailyKeyPerformanceMetrics?.[dailyReqType]
        requestFunc(params).then((result: any) => {
            setError(false)
            setLoading(false);
            setComponentData(result);
            dispatch({
                type: "overview/getDailyKeyPerformanceMetrics",
                payload: {
                    result
                }
            });
        }).catch((err: any) => {
            setError(true)
            setLoading(false);
        })
    }
    return {
        // nodata 不在此封装，因为可能是接口的个别项目nodata
        componentData,
        loading,
        error,
    }
}

export default useDailyKeyMetricsModel;
